import { createAction } from '@reduxjs/toolkit';
import { PointsBurn } from 'types/pointsBurn';

export const setPointsBurnTiers = createAction<Omit<PointsBurn, 'id'>>('pointsBurnTiers/SET_POINTS_BURN_TIERS');
export const fetchPointsBurnTiers = createAction('pointsBurnTiers/FETCH_POINTS_BURN_TIERS');
export const clearPointsBurnTiers = createAction('pointsBurnTiers/CLEAR_POINTS_BURN_TIERS');
